<template>
  <div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0">
            {{ $t('review.self_multiple') }}
          </h5>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <b-button
            variant="primary"
            @click="resetFilters"
          >
            {{ $t('review.reset_filters') }}
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <a-table
          class="product-table"
          :columns="columns"
          :data-source="data"
          :pagination="pagination"
          :row-key="(record, index) => index"
          :scroll="{x: 1280}"
          @change="handleTableChange"
        >
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown"
          >
            <a-input
              v-ant-ref="c => searchInput = c"
              :placeholder="`${$t('common.search')} ${column.dataIndex}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
            />
            <a-button
              type="primary"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(selectedKeys, confirm)"
            >
              {{ $t('common.search') }}
            </a-button>
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
            >
              {{ $t('common.reset') }}
            </a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="date_created"
            slot-scope="text"
          >
            {{ text | dateFormatter('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template
            slot="order"
            slot-scope="text"
          >
            <router-link :to="`../seller/orders/${text.hash_id}`">
              {{ text.id }}
            </router-link>
          </template>
          <template
            slot="item"
            slot-scope="text"
          >
            <router-link
              v-for="product in text"
              :key="product.id"
              :to="`../library/product/${product.hash_id}`"
            >
              <ShrinkStringDisplay :string="$l(product.variation.title)" /><br>
            </router-link>
          </template>
          <template
            slot="author"
            slot-scope="text"
          >
            <span v-if="text.name">
              {{ text.name }}
              <span v-if="text.phone"> {{ text.phone | phoneFormatter }} </span>
              <span v-else-if="text.email"> ({{ text.email }})</span>
            </span>
          </template>
          <template
            slot="status"
            slot-scope="text"
          >
            <b-badge
              v-if="text === 'PENDING'"
              variant="primary"
              class="p-2"
            >
              {{ $t(`moderation.${text}`) }}
            </b-badge>
            <b-badge
              v-else-if=" text === 'ACCEPTED'"
              variant="success"
              class="p-2"
            >
              {{ $t(`moderation.${text}`) }}
            </b-badge>
            <b-badge
              v-else-if=" text === 'REJECTED'"
              variant="warning"
              class="p-2"
            >
              {{ $t(`moderation.${text}`) }}
            </b-badge>
            <b-badge
              v-else
              variant="danger"
              class="p-2"
            >
              {{ $t(`moderation.${text}`) }}
            </b-badge>
          </template>
          <template
            slot="action"
            slot-scope="record"
          >
            <router-link :to="`./reviews/${record.hash_id}`">
              <b-button
                size="sm"
                variant="light"
                class="mr-2"
              >
                <i class="fe fe-edit mr-2" />
                {{ $t('common.view') }}
              </b-button>
            </router-link>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import reviewModerationService from '@/services/api/admin/review-moderation-service'
import ShrinkStringDisplay from '@/components/common/ShrinkStringDisplay'

export default {
  name: 'Reviews',
  components: { ShrinkStringDisplay },
  data: function () {
    return {
      searchText: '',
      pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
      },
      sorting: {
        col: 'date_created',
        order: 'desc',
      },
      filters: {},
      searchInput: null,
      data: [],
    }
  },

  computed: {
    columns() {
      return [
        {
          title: this.$t('common.date'),
          dataIndex: 'date_created',
          sorter: true,
          scopedSlots: { customRender: 'date_created' },
        },
        {
          title: this.$t('orders.order') + ' №',
          dataIndex: 'order',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'order',
          },
        },
        {
          title: this.$t('product.self'),
          dataIndex: 'products',
          scopedSlots: { customRender: 'item' },
        },
        {
          title: this.$t('review.author'),
          dataIndex: 'author',
          sorter: true,
          scopedSlots: {
            customRender: 'author',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: this.$t('topBar.status'),
          sorter: true,
          dataIndex: 'moderation_status',
          filters: [
            { text: this.$t('moderation.PENDING'), value: 'PENDING' },
            { text: this.$t('moderation.ACCEPTED'), value: 'ACCEPTED' },
            { text: this.$t('moderation.REJECTED'), value: 'REJECTED' },
            { text: this.$t('moderation.REMOVED'), value: 'REMOVED' },
          ],
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },

  mounted () {
    this.fetchFilterFromParams()
    this.queryReviews()
  },
  methods: {
    resetFilters() {
      this.filters = {}
      this.sorting = {}
      this.queryReviews()
      this.saveRouteParams()
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    handleTableChange(pagination, filter, sorter) {
      if (sorter.columnKey && sorter.order)
        this.sorting = {
          col: sorter.columnKey,
          order: sorter.order.replace('end', ''), // ascend -> asc | descend -> desc
        }

      Object.keys(filter).forEach(key => {
        if (filter[key] && filter[key].length > 0)
          this.filters[key] = filter[key]
        else
          this.filters[key] = null
      })

      this.pagination.current = pagination.current

      this.queryReviews()

      this.saveRouteParams()
    },
    queryReviews () {
      reviewModerationService.fetchReviews(this.pagination, this.sorting, this.filters)
        .then((response) => {
          if (response && response.data && response.data.content) {
            this.data = response.data.content
            this.pagination.total = response.data.pagination.total
          }
        })

      this.pagination.total = 50
    },
    fetchFilterFromParams () {
      Object.keys(this.$route.query).forEach((key) => {
        if (key === 'current' || key === 'pageSize') {
          this.pagination[key] = parseInt(this.$route.query[key])
        } else if (key === 'col' || key === 'order') {
          this.sorting[key] = this.$route.query[key]
        } else {
          const queryValue = this.$route.query[key]
          if (Array.isArray(queryValue))
            this.filters[key] = queryValue.slice()
          else
            this.filters[key] = [queryValue]
        }
      })
    },
    saveRouteParams () {
      const queryParams = {}
      Object.keys(this.filters)
        .forEach((key) => {
          if (this.filters[key]) {
            queryParams[key] = this.filters[key]
          }
        })

      queryParams.current = this.pagination?.current ?? 1
      queryParams.pageSize = this.pagination?.pageSize ?? 25

      queryParams.col = this.sorting?.col ?? 'date_created'
      queryParams.order = this.sorting?.order ?? 'desc'

      this.$router.push({ name: 'reviews', query: queryParams })
    },
    stringifyItems (item) {
      try {
        return this.$l(item)
      } catch (e) {
        return item.toString()
      }
    },
    calculateMinRating (review) {
      const rating = review.item.map((it) => it.rating)
      rating.push(review.seller_rating)
      return Math.min(...rating)
    },
    getWorstContent (review) {
      let worst = review.seller_content
      let minRating = review.seller_rating

      review.item.forEach((it) => {
        if (it.rating < minRating) {
          worst = it.content
          minRating = it.rating
        }
      })

      return worst
    },
  },
}
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
